import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Input, Typography } from "antd";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";

const { Text } = Typography;

const IyePopup = ({
  visible,
  onClose,
  phoneNumber,
  onVerify,
}: {
  visible: boolean;
  onClose: () => void;
  phoneNumber: string;
  onVerify: (otp: string) => void;
}) => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [timeLeft, setTimeLeft] = useState(60);
  const inputsRef = useRef<Array<any>>([]);

  // Countdown timer
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
    return () => clearTimeout(timer);
  }, [timeLeft]);

  const handleChange = (value: string, index: number) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      // Move to next input if value entered
      if (value && index < 3) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handleVerify = () => {
    onVerify(otp.join(""));
  };

  const handleResend = () => {
    setOtp(["", "", "", ""]);
    setTimeLeft(60);
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      closeIcon={<CloseOutlined />}
      bodyStyle={{ borderRadius: 20, padding: "30px 25px", textAlign: "left" }}
    >
      <h3>Verification</h3>
      <Text type="secondary">Verification Code was sent to</Text>
      <div
        style={{
          background: "#f5f5f5",
          padding: "8px 12px",
          borderRadius: 20,
          margin: "10px 0 20px",
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        {phoneNumber}
        <EditOutlined style={{ color: "#ffb400", fontSize: 16 }} />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 12,
          marginBottom: 15,
        }}
      >
        {otp.map((digit, i) => (
          <Input
            key={i}
            // ref={(el) => (inputsRef.current[i] = el)}
            value={digit}
            onChange={(e) => handleChange(e.target.value, i)}
            onKeyDown={(e) => handleKeyDown(e, i)}
            maxLength={1}
            style={{
              width: 50,
              height: 50,
              textAlign: "center",
              fontSize: 20,
              borderRadius: 12,
              border: digit ? "2px solid #35b558" : "1px solid #d9d9d9",
              backgroundColor: digit ? "#35b558" : "#fff",
              color: digit ? "#fff" : "#000",
              transition: "all 0.2s",
            }}
          />
        ))}
      </div>

      <Text
        type="danger"
        style={{ display: "block", marginBottom: 10, textAlign: "center" }}
      >
        00:{timeLeft < 10 ? `0${timeLeft}` : timeLeft} Sec
      </Text>

      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <Button type="link" onClick={handleResend}>
          Resend Code
        </Button>
      </div>

      <Button
        type="primary"
        block
        style={{
          borderRadius: 25,
          padding: "10px 0",
          background: "#35b558",
          border: "none",
          color: "#fff",
        }}
        onClick={handleVerify}
        disabled={otp.includes("")}
        className="login-btn w-100 rounded-pill p-4"
      >
        Verify
      </Button>
    </Modal>
  );
};

export default IyePopup;
